import { render, staticRenderFns } from "./RegisterFromReferalPage.vue?vue&type=template&id=1bd0483d&scoped=true&"
import script from "./RegisterFromReferalPage.vue?vue&type=script&lang=js&"
export * from "./RegisterFromReferalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd0483d",
  null
  
)

export default component.exports